import React from 'react';
import { useLocation } from 'react-router-dom';
import { Menu, Bell } from 'lucide-react';

const TITULOS = {
  '/dashboard':  'Dashboard',
  '/documentos': 'Documentos Fiscais',
  '/empresas':   'Empresas',
  '/usuarios':   'Usuários',
  '/api-keys':   'API Keys (Integração ERP)',
  '/auditoria':  'Log de Auditoria',
  '/perfil':     'Meu Perfil',
};

export default function Header({ onAbrirSidebar }) {
  const { pathname } = useLocation();
  const titulo = TITULOS[pathname] || 'Kairós Storage Fiscal';

  return (
    <header className="h-14 border-b border-surface-border bg-[#0a0f1e]/80 backdrop-blur-sm flex items-center justify-between px-4 lg:px-6 sticky top-0 z-10">
      <div className="flex items-center gap-3">
        <button
          onClick={onAbrirSidebar}
          className="lg:hidden text-slate-400 hover:text-white p-1.5 rounded-lg hover:bg-surface-card"
        >
          <Menu size={20} />
        </button>
        <h1 className="text-sm font-semibold text-slate-200">{titulo}</h1>
      </div>

      <div className="flex items-center gap-2">
        <button className="relative text-slate-500 hover:text-slate-300 p-2 rounded-lg hover:bg-surface-card transition-colors">
          <Bell size={18} />
        </button>
      </div>
    </header>
  );
}
